
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.063 28.146v.416l-1.542 1.542h-.417l-2.833-2.854-2.854 2.854H22l-1.541-1.541v-.417l2.854-2.854-2.854-2.855v-.416L22 20.5h.417l2.854 2.854 2.833-2.854h.417l1.542 1.52v.418l-2.854 2.854 2.854 2.854zm12.875-5.48c-1.25-9.383-9.524-16.214-18.974-15.665-9.45.548-16.878 8.293-17.032 17.757-.155 9.465 7.016 17.447 16.443 18.305l.25.291v2.188l-.312.291C12.072 44.92 3.599 35.227 4.196 23.966 4.793 12.702 14.243 3.96 25.518 4.241c11.274.28 20.279 9.48 20.316 20.758v1.354a20.582 20.582 0 01-2.271 7.334h-.542l-3.167-10.771.292-.375 2.792.125z","clip-rule":"evenodd"}})])
          )
        }
      }
    